import React from 'react';

export default function Text({content = ''}) {
  return <div className="prose max-w-xl mx-auto" dangerouslySetInnerHTML={{ __html: content.replace(/\[.*\]/g, '') }}/>;
}
